module.exports = __webpack_public_path__ + "img/img-gzt-3.4f1c0ee5.png";